var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-row',{attrs:{"noGutters":""}},[_c('BaseSidebar',{attrs:{"items":_vm.sidebarItems,"title":_vm.$t('roles.members')}}),_c('v-col',[_c('TeamMembers')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }